import { render, staticRenderFns } from "./CustomRadio.vue?vue&type=template&id=3a6eb5c8&scoped=true"
import script from "./CustomRadio.vue?vue&type=script&lang=js"
export * from "./CustomRadio.vue?vue&type=script&lang=js"
import style0 from "./CustomRadio.vue?vue&type=style&index=0&id=3a6eb5c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6eb5c8",
  null
  
)

export default component.exports